import { useState, useEffect } from "react";
import { Modal, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";

const SingleSelectFilterModal = ({
  isOpen,
  onClose,
  onApply,
  title,
  options = [],
  currentValue,
  getOptionDataAttribute,
  maxWidth = "400px",
}) => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(currentValue || "all");

  useEffect(() => {
    if (isOpen) {
      setSelectedValue(currentValue || "all");
    }
  }, [isOpen, currentValue]);

  const handleApply = () => {
    onApply(selectedValue);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      contentClassName="rounded-lg char-modal-content"
      style={{ maxWidth }}
      centered
    >
      <div className="char-modal-stack">
        <div className="char-modal-header">
          <span className="char-modal-header-title">{title}</span>
          <button
            type="button"
            onClick={onClose}
            className="char-modal-header-close"
            aria-label={t("Close")}
          >
            <i className="fas fa-times char-modal-header-close-icon" />
          </button>
        </div>
        <div className="char-status-modal-list">
          {options.map((option) => {
            const isSelected = String(selectedValue) === String(option.value);

            return (
              <label
                key={option.value}
                className="char-status-modal-checkbox"
                data-status={
                  getOptionDataAttribute
                    ? getOptionDataAttribute(option)
                    : option.value
                }
              >
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => setSelectedValue(option.value)}
                  className="char-status-modal-checkbox-input"
                />
                <span className="char-status-modal-checkbox-label">
                  {option.label}
                  {option.suffix ? ` ${option.suffix}` : ""}
                </span>
              </label>
            );
          })}
        </div>
      </div>
      <ModalFooter className="char-modal-footer">
        <button type="button" onClick={onClose} className="char-button">
          {t("Cancel")}
        </button>
        <button
          type="button"
          onClick={handleApply}
          className="char-button char-button-primary"
        >
          {t("Apply")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default SingleSelectFilterModal;
